<script>
  import { generateColorFromString } from '$lib/utils/colors';

  export let bgImage = '';
  export let appName = '';
</script>

<div class="aspect-square w-full rounded-lg bg-cover bg-center overflow-hidden" style="background-color: {generateColorFromString(appName)}">
  <div class="h-full w-full bg-cover bg-center" style="background-image: url('{bgImage}')" />
</div>
